<template>
  <div>
    <div class="mt-login-bg">
      <div class="mt-login-fff">
        <div class="mt-login-title">{{ loginTitle }}</div>
        <div class="mt-login-type-tabs">
          <span
            v-for="item in loginTypes"
            :key="item.value"
            :class="['mt-login-type-tab', { active: loginType === item.value }]"
            @click="loginType = item.value"
          >{{ item.label }}</span>
        </div>
        <div>
          <div class="mt-login-row">
            <i class="el-icon-user mt-login-row-icon"></i>
            <input v-model="username" class="mt-login-row-input" type="text" placeholder="请输入账号" />
          </div>
          <div class="mt-login-row">
            <i class="el-icon-lock mt-login-row-icon"></i>
            <input v-model="pwd" class="mt-login-row-input" type="password" placeholder="请输入密码" />
          </div>
        </div>
        <el-button class="mt-login-btn bg-theme color-fff" type="primary" @click="loginBtn" v-loading.fullscreen.lock="fullscreenLoading">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { login } from '@/api/login'
export default {
  name: 'Login',
  data () {
    return {
      fullscreenLoading: false,
      username: '',
      pwd: '',
      loginType: 'management',
      loginTypes: [
        { value: 'management', label: '平台管理' },
        { value: 'shop', label: '店铺管理' },
        { value: 'journey', label: '基地管理' }
      ]
    }
  },
  computed: {
    loginTitle () {
      const titles = {
        management: '文森卡商城管理系统',
        shop: '店铺后台-账号登录',
        journey: '基地后台-账号登录'
      }
      return titles[this.loginType] || '账号登录'
    }
  },
  mounted () {
    const savedType = sessionStorage.getItem('loginType')
    if (savedType) {
      this.loginType = savedType
    }
  },
  methods: {
    loginBtn () {
      let that = this
      let username = that.username
      let pwd = that.pwd
      if (username === '') {
        this.$message.error('请输入账号')
        return false
      }
      if (pwd === '') {
        this.$message.error('请输入密码')
        return false
      }
      that.fullscreenLoading = true
      login({ userName: username, password: pwd }, that.loginType).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          let data = res.data
          sessionStorage.setItem('token', data.token)
          Vue.prototype.$token = data.token
          sessionStorage.setItem('userName', data.userName)
          sessionStorage.setItem('loginType', that.loginType)
          sessionStorage.setItem('childrenMenuList', JSON.stringify(data.childrenMenuList))
          sessionStorage.setItem('isJourneyUser', JSON.stringify(data.isJourneyUser))
          var toPath = data.childrenMenuList[0].component
          if (toPath == null) {
            toPath = data.childrenMenuList[0].children[0].component
            if (toPath == null) {
              toPath = data.childrenMenuList[0].children[0].children[0].component
            }
          }
          that.$router.push(toPath)
          this.$message({
            message: res.msg,
            type: 'success'
          })
        }
        if (res.errorCode === '1001') {
          that.fullscreenLoading = false
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.mt-login-type-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  gap: 12px;
}
.mt-login-type-tab {
  padding: 6px 14px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.mt-login-type-tab.active {
  color: #fff;
  background: #1890FF;
  border-color: #1890FF;
}
.mt-login-row-icon {
  font-size: 20px;
  color: #999;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue